import Footer from '@/components/Footer'
import Recognition from '@/components/Recognition'
import StartaProject from '@/components/StartaProject'
import Whatwedo from '@/components/Whatwedo'
import React from 'react'
import Banner from '@/components/about/Banner'
import Testimonial from '@/components/comman/Testimonial'
import Since from '@/components/about/Since'
import MeetDirector from '@/components/about/MeetDirector'
import Head from 'next/head'
import { getHomePageData  } from '../../lib/home';

import { getAboutData  } from '../../lib/about';
import { GetStaticProps } from 'next'
import { getSeoData  } from '../../lib/seo';
import SEO from '@/components/SEO'

function About({aboutData, initialHomePageData, initialSeo}:any) {

  const bannerContent = aboutData?.content
  const bannerData = aboutData?.about?.bannerSection;
  const sinceData = aboutData?.about?.sinceSection;
  const meetDirectorsData = aboutData?.about?.meetOurDirectors;
  const wwdData = initialHomePageData?.home?.whatWeDo;


  return (
    <div className='aboutus_page'>
      
        <SEO initialSeo={initialSeo}/>
        
        <Banner data={bannerData} content={bannerContent}/>
        <Testimonial/>
        <Since data={sinceData}/>
        <MeetDirector data={meetDirectorsData}/>
        <Recognition/>
        <Whatwedo wwdData={wwdData}/>
        <StartaProject/>
    </div>
  )
}

export default About

export const getStaticProps: GetStaticProps = async () => {
  const aboutData = await getAboutData()
  const initialSeo = await getSeoData("about")
  const initialHomePageData = await getHomePageData()
  return {
      props: { aboutData, initialHomePageData, initialSeo}
  }
}